import { render } from "./ValidasiTTe.vue?vue&type=template&id=30e22c64&ts=true"
import script from "./ValidasiTTe.vue?vue&type=script&lang=ts"
export * from "./ValidasiTTe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__